<template>
  <el-form :rules="typerules" ref="typeform" :model="typeform" label-width="100px">
    <el-form-item :label="$t('addType.company', { msg: 'addType.company' })" prop="companyID">
      <el-col :span="8">
        <el-select style="width: 345px" v-model="typeform.companyID" :placeholder="$t('addType.companyS', { msg: 'addType.companyS' })" >
          <el-option v-for="item in allusercompany"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-form-item>
    <el-form-item :label="$t('addType.type', { msg: 'addType.type' })" prop="name">
      <el-col :span="8">
        <el-input style="width: 345px" v-model="typeform.name" :placeholder="$t('addType.typeS', { msg: 'addType.typeS' })"></el-input>
      </el-col>
    </el-form-item>
    <el-form-item style="text-align: left">
      <el-button type="primary" @click="onTypeSubmit('typeform')">{{ $t('addType.confirm', { msg: 'addType.confirm' }) }}</el-button>
      <el-button @click="reset()" style="position: relative">{{ $t('issueTrack.rs', { msg: 'issueTrack.rs' }) }}</el-button>
    </el-form-item>
  </el-form>
  <el-table
      highlight-current-row
      stripe
      border
      :data="alltype.filter(item => item.companyID === typeform.companyID)"
      row-class-name="tableRowClassName"
      style="width: 100%"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}">
    <el-table-column
        prop="value"
        :label="$t('addType.id', { msg: 'addType.id' })"
        >
    </el-table-column>
    <el-table-column
        prop="text"
        :label="$t('addType.typeName', { msg: 'addType.typeName' })"
        >
    </el-table-column>
    <!-- 只替换原来的禁用状态列 -->
    <el-table-column :label="$t('addType.typeDisable', { msg: 'addType.typeDisable' })" >
      <template #default="scope">
        <el-switch
          style="display: block"
          v-model="scope.row.disable"
          :active-value="0"
          :inactive-value="1"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-text="$t('addType.enable', { msg: 'addType.enable' })"
          :inactive-text="$t('addType.disable', { msg: 'addType.disable' })"
          :disabled="!userRole.includes('超级管理员')"
          @change="editQTDisable(scope.row.value,scope.row.disable)"
        />
      </template>
    </el-table-column>
    <el-table-column :label="$t('addType.opr', { msg: 'addType.opr' })" v-if="userRole.includes('超级管理员')">
      <template #default="scope">
        <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">{{ $t('charger.delete', { msg: 'charger.delete' }) }}</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {addType, getusercompany} from "@/axios";
import {deleteType, getalltype,editQTDisable} from "../../axios";

export default {
  name: "addtype",
  props:['userid','username','realname','role','companyID','usercompany'],

  data(){
    return {
      allusercompany: [],
      alltype: [],
      typerules: {
        name: [{
          required: true, message: this.$t('addType.typeS', { msg: 'addType.typeS' }), trigger: 'blur'
        }],
        companyID: [{
          required: true, message: this.$t('addType.companyD', { msg: 'addType.companyD' }), trigger: 'blur'
        }]
      },
      typeform: {
        name: '',
        companyID: '',
        userId:''
      },
      userRole:'',

    }
  },
  created() {
    this.getUserCompany();
    this.getAllType();
    this.getUserRole();
  },
  methods:{
    getAllType(){ //获得所有问题类型
      getalltype().then(res=>{
        this.alltype.splice(0,this.alltype.length);
        for (let i=0 ;i<res.count;i++){
          this.alltype.push({
            text: res.data[i].name,
            label: res.data[i].name,
            value: res.data[i].type,
            disable: res.data[i].disable,
            companyID: res.data[i].companyID
          });
        }
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },
   //修改禁用状态
    editQTDisable(type, disable) {
      // 组装成后端需要的 JSON
      const params = { type, disable };
      editQTDisable(params)          // 这里才是真正发请求的 axios 方法
        .then(res => {
          if (res === '修改成功') {
            this.$message.success(this.$t('addType.successtips', { msg: 'addType.successtips' }));
          } else {
            // 失败回滚：把当前行数据再翻转回来
            this.flipDisable(type);
            this.$message.error('修改失败');
          }
        })
        .catch(() => {
          this.flipDisable(type);
          this.$message.error('网络错误');
        });
    },

    /* 辅助：根据 type 找到行并翻转 disable */
    flipDisable(type) {
      const row = this.alltype.find(r => r.value === type);
      if (row) row.disable = row.disable === 0 ? 1 : 0;
    },
    //disable对应行显示黄色
    tableRowClassName({ row }) {
    // 当 disable 为 1 时返回黄色类名
    return row.disable === 1 ? 'disable-row' : '';
  },
    getUserCompany(){
      getusercompany({
        companyID: this.companyID
      }).then(res=>{
        this.allusercompany.splice(0,this.allusercompany.length);
        for (let i=0 ;i<res.count;i++){
          this.allusercompany.push({text: res.data[i].companyname,label: res.data[i].companyname,value: res.data[i].companyID});
        }
        this.allusercompany.sort(function(a,b){return a.label>b.label ? 1:-1;}); //将公司根据公司名排序
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },
    onTypeSubmit(formName){  //新增类型
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.typeform.userId=sessionStorage.getItem("userid");
          addType(this.typeform).then(res=>{
            if(res === '添加成功'){
              this.$message.success(this.$t('issue.addS', { msg: 'issue.addS' }));
              this.typeform.name = '';
              this.typeDialogVisible = false;
              // console.log(this.typeform);
              this.getAllType();
            }else if(res === '记录重复'){
              this.$message.error(this.$t('issue.sameRe', { msg: 'issue.sameRe' }))
            }else{
              this.$message.error(this.$t('issue.addF', { msg: 'issue.addF' }))
            }

          }).catch(err=>{
            console.log(err);
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(){
      this.typeform.name = '';
      this.typeform.companyID = '';
    },
    handleDelete(index,row){
      this.$confirm(this.$t('addType.info', { msg: 'addType.info' }), this.$t('issue.tips', { msg: 'issue.tips' }), {
        confirmButtonText: this.$t('addType.confirm', { msg: 'addType.confirm' }),
        cancelButtonText: this.$t('addType.cancel', { msg: 'addType.cancel' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        deleteType({id: row.value}).then(res => {
          if(res === '删除成功'){
            this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }))
          }else if(res === '删除失败'){
            this.$message.error(this.$t('issue.deleteF', { msg: 'issue.deleteS' }))
          }else{
            this.$message.error(this.$t('addType.existOtherIssue', { msg: 'addType.existOtherIssue' }))
          }
          // this.$message.success(res);
          this.getAllType();
        }).catch(err => {
          console.log(err);
        })
      }).catch(err=>{
        console.log(err);
      });
    },

    getUserRole(){
          this.userRole=sessionStorage.getItem('role');
        },

  }
}
</script>

<style scoped>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}

/* 黄色背景 */
.disable-row {
  background-color: hsl(50, 84%, 59%) !important;
}
</style>
